import React from "react";
import LookupManagerPage from "./LookupManagerPage";

function PillarsPage() {
  return (
    <LookupManagerPage
      title="Pillars"
      endpoint="/pillars"
      createPath="/pillars/new"
      editPathBase="/pillars"
      fields={[
        { name: "name", label: "Name" },
        { name: "description", label: "Description", type: "textarea", required: false }
      ]}
    />
  );
}

export default PillarsPage;
